import { render, staticRenderFns } from "./SugokuRare.vue?vue&type=template&id=2ea1d96a"
import script from "./SugokuRare.vue?vue&type=script&lang=js"
export * from "./SugokuRare.vue?vue&type=script&lang=js"
import style0 from "./SugokuRare.vue?vue&type=style&index=0&id=2ea1d96a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports